import logService from '../../../../services/wss/logService3';
import userTopicService from '../../../../services/UserTopicService';
import responseHelper from '../../../../services/ResponseHelper';

const _name = 'GroupNodeFetcher';
const PAGE_SIZE = 25;

/**
 * Fetches node entries from the API.
 * No cache, no state, no side effects beyond the HTTP call.
 * Returns node data on success, null on failure.
 */
export default class GroupNodeFetcher {
    /**
     * Fetches a page of entries for a node.
     * @param {string} gid - group rk
     * @param {string} nid - node id e.g. g1, g2
     * @param {number} page
     * @returns {object|null}
     */
    fetchPage = async (gid, nid, page) => {
        try {
            const result = await userTopicService.getGroupEntries(gid, nid, page, PAGE_SIZE);
            return {
                entries: result?.data?.items ?? [],
                total: result?.data?.total ?? 0,
                page: result?.data?.page ?? 1,
            };
        } catch (error) {
            logService.logError(`${_name}.fetchPage: ${error.message}`);
            return null;
        }
    };

    /**
     * Fetches all nodes for a group on manual switch.
     * Same response shape as OnGroupNodesLoaded SignalR event.
     * @param {string} gid - group rk
     * @returns {object|null}
     */
    fetchNodes = async (gid) => {
        try {
            const resp = await userTopicService.getGroupNodes(gid);
            const code = responseHelper.check(resp, 'fetchNodes', _name);
            if (code < 0) {
                logService.logError(`${_name}.fetchNodes: code=${code} status=${resp.status}`);
                return null;
            }

            const data = resp.data;
            data.nodes = resp.data.items;
            return data;
        } catch (error) {
            logService.logError(`${_name}.fetchNodes: ${error.message}`);
            return null;
        }
    };
}
